import React from 'react'
import styled from 'styled-components'
import { colors, breakpoints } from 'globalStyles'
import Spinner from 'react-bootstrap/Spinner'

const StyledSpinner = styled(Spinner)`
  color: ${colors.text_link_hover};
  width: 40px;
  height: 40px;

  @media ${breakpoints.tablet} {
    width: 60px;
    height: 60px;
  }
  @media ${breakpoints.desktop} {
    width: 60px;
    height: 60px;
  }
`

const LoadingSpinner = () => {
  return (
    <StyledSpinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </StyledSpinner>
  )
}

export default LoadingSpinner
